import { render, staticRenderFns } from "./CpfAndPhone.vue?vue&type=template&id=0f85cada"
import script from "./CpfAndPhone.vue?vue&type=script&lang=js"
export * from "./CpfAndPhone.vue?vue&type=script&lang=js"
import style0 from "./CpfAndPhone.vue?vue&type=style&index=0&id=0f85cada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports